import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import { apiFetch, setToken } from './api';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    apiFetch('/api/auth/me', { reloadOnAuthError: false })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data && data.user) setUser(data.user);
      })
      .catch(() => {});
  }, []);

  const handleLogin = (username) => setUser(username);
  const handleLogout = () => {
    apiFetch('/api/auth/logout', { method: 'POST' })
      .finally(() => {
        setToken(null);
        setUser(null);
      });
  };

  return (
    <div className="app">
      {user ? <Dashboard username={user} onLogout={handleLogout} /> : <Login onLogin={handleLogin} />}
    </div>
  );
}

export default App;
